.hint {
  margin: 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.4;
}

.link {
  color: var(--accent);
  text-decoration: none;
}
